import { getTime, subDays } from 'date-fns';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { actions as userActions } from '@saucelabs/sl-module-user';

import * as actions from './actions';
import { actions as filtersActions } from './../../ducks/filters';
import { actions as teamsActions } from './../../ducks/teams';
import { TABLE_DATA_PERIOD } from './../activity/constants';
import { actions as usersActions, operations as usersOperations } from './../../ducks/users';
import { utils as tmUtils } from './../team-management';

export const patchTeam = ({ id, data }) => (dispatch) => (
  dispatch(actions.patchTeam({ id, data }))
    .then(() => {
      dispatch(notificationActions.notifySuccess('Team updated'));
    })
);

export const updateTableOffset = (payload) => (dispatch, getState) => {
  const offset = (payload - 1) * PAGINATION_LIMIT;
  const allFilters = tmUtils.serializeFilters(getState().apps.teamManagement.teamDetails.get('selectedFilters'));
  dispatch(usersActions.saveTableOffset(payload));
  dispatch(usersOperations.getAllUserListData({ offset, allFilters }));
};

export const toggleFilter = (payload) => (dispatch, getState) => {
  const filters = tmUtils.updateFilter(
    getState().apps.teamManagement.teamDetails.getIn(['selectedFilters', payload.label]),
    payload.value,
  );

  dispatch(actions.updateFilter({ label: payload.label, value: filters }));
  dispatch(updateTableOffset(1)); // reset pagination to first page and refetch data
};

export const getInitialTeamDetails = (id) => (dispatch) => {
  dispatch(actions.getInitialTeamDetailsRequest());
  return Promise.all([
    dispatch(toggleFilter({ label: 'teams', value: id })), // fetches user list as well
    dispatch(teamsActions.getTeamList()),
    dispatch(actions.getTeam({ id })),
    dispatch(filtersActions.getFilters({ team: id })),
  ])
    .then(() => {
      dispatch(actions.getInitialTeamDetailsSuccess());
    })
    .catch((error) => {
      dispatch(actions.getInitialTeamDetailsFailure(error));
      throw error;
    });
};

export const batchMoveFromDefaultTeam = ({ teamId, users }) => (dispatch, getState) => {
  const organizationId = getState().user.get('organization').id;
  const teamAssignmentRequests = users
    .map((user) => dispatch(usersOperations.teamAssignment({
      userId: user.id,
      teamId,
      organizationId,
    })))
    .toArray();

  // FIXME: it will work for 2-4 changes at once, but wont for eg 100
  return Promise.all(teamAssignmentRequests).then(
    () => {
      const usernames = users.map((user) => user.username).toArray();
      const userIds = users.map((user) => user.id).toArray();
      const successText = `The following users were moved to your team: ${usernames.join(', ')}`;
      dispatch(notificationActions.notifySuccess(successText));
      dispatch(actions.movedSelectedUsersToTeam());
      dispatch(userActions.getUserListLastJobs({ users: userIds }));
      dispatch(filtersActions.getFilters({ team: teamId }));
      dispatch(userActions.getUserListActivity({
        users: userIds,
        since: Math.round(getTime(subDays(new Date(), TABLE_DATA_PERIOD)) / 1000), // API expects seconds instead of miliseconds
      }));
    },
    () => dispatch(notificationActions.notifyDanger('Something went wrong with team assignment')),
  );
};
